import { Link } from 'react-router-dom';
import { business } from '../data/business';
import './LegalPage.css';

function PrivacyPage() {
  return (
    <main className="legal-page">
      <div className="legal-page__inner">
        <p className="legal-page__eyebrow">Policy</p>
        <h1>개인정보처리방침</h1>
        <p className="legal-page__lead">
          {business.name}(이하 &quot;회사&quot;)는 개인정보 보호법 등 관련 법령을 준수하며,
          {business.productName} 서비스 이용자의 개인정보를 보호하기 위해 다음과 같이 처리합니다.
        </p>

        <section>
          <h2>1. 개인정보의 처리 목적</h2>
          <ul>
            <li>부스 도입 문의 접수, 상담 및 안내</li>
            <li>서비스 제공, 계약 이행 및 고객 지원</li>
            <li>서비스 개선을 위한 통계·분석(비식별·집계 포함)</li>
          </ul>
        </section>

        <section>
          <h2>2. 처리하는 개인정보 항목</h2>
          <ul>
            <li>문의: 이름, 전화번호, 주소</li>
            <li>서비스 이용 과정에서 생성되는 기록(접속 로그 등)</li>
          </ul>
        </section>

        <section>
          <h2>3. 개인정보의 보유 및 이용 기간</h2>
          <p>
            원칙적으로 수집·이용 목적이 달성되면 지체 없이 파기합니다. 다만 관련 법령에 따라 일정
            기간 보관이 필요한 경우 해당 기간 동안 보관합니다.
          </p>
        </section>

        <section>
          <h2>4. 개인정보의 제3자 제공</h2>
          <p>
            회사는 이용자의 동의 없이 개인정보를 제3자에게 제공하지 않습니다. 다만 법령에 근거가
            있거나 수사기관의 요청이 있는 경우 등 예외가 있을 수 있습니다.
          </p>
        </section>

        <section>
          <h2>5. 개인정보 처리의 위탁</h2>
          <p>
            원활한 서비스 제공을 위해 처리 업무를 위탁할 수 있으며, 위탁 시 관련 법령에 따라
            안전하게 관리되도록 감독합니다.
          </p>
        </section>

        <section>
          <h2>6. 정보주체의 권리</h2>
          <p>
            이용자는 개인정보 열람, 정정·삭제, 처리정지, 동의 철회를 요청할 수 있습니다. 요청은
            아래 연락처로 문의해 주세요.
          </p>
        </section>

        <section>
          <h2>7. 개인정보 보호책임자</h2>
          <ul>
            <li>상호: {business.name}</li>
            <li>대표: {business.representative}</li>
            <li>주소: {business.address}</li>
            <li>이메일: {business.email}</li>
          </ul>
        </section>

        <section>
          <h2>8. 고지의 의무</h2>
          <p>
            본 방침이 변경되는 경우 웹사이트를 통해 공지합니다. 본 방침은 게시일부터 적용됩니다.
          </p>
        </section>

        <Link to="/" className="legal-page__back">
          ← 랜딩으로 돌아가기
        </Link>
      </div>
    </main>
  );
}

export default PrivacyPage;
